<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
    			<div class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100">
    				<h1 class="title">Welcome to <br/> The Barkers</h1>
              <h4>As you can see, this is the site for our family.  There probably isn't much here that you are interested in seeing.  But, you can always check out the recipes or the about pages.</h4>
    			</div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section text-center">
        <div class="container">
          <h2 class="title">Our Family</h2>
          <div class="team">
              <div class="md-layout">
                  <div class="md-layout-item md-medium-size-33 md-small-size-100">
                    <div class="team-player">
                      <md-card class="md-card-plain">
                        <div class="md-layout-item md-size-50 mx-auto">
                          <img :src="phil" alt="Phil Image" class="img-raised rounded-circle img-fluid">
                        </div>
                        <h4 class="card-title">Phil
                          <br>
                          <small class="card-description text-muted">FiFi</small>
                        </h4> 

                        <md-card-content>
                          <p class="card-description">I'm the husband and dad (obvious, no?). I cook and clean and do the dishes. And, I'm more than a little anal about it all. On occasion, I even write some software.</p>
                        </md-card-content>

                        <md-card-actions class="text-center">
                          <md-button href="javascript:void(0)" class="md-just-icon md-simple">
                            <a href="http://www.the-barkers.org/phil_barker_resume.pdf" target="_new"><i class="fas fa-file-pdf"></i></a>
                          </md-button>
                          <md-button href="javascript:void(0)" class="md-just-icon md-simple">
                            <a href="https://www.linkedin.com/in/philbarker/" target="_new"><i class="fab fa-linkedin"></i></a>
                          </md-button>
                        </md-card-actions>
                      </md-card>
                    </div>
                  </div>
                  <div class="md-layout-item md-medium-size-33 md-small-size-100">
                    <div class="team-player">
                      <md-card class="md-card-plain">
                        <div class="md-layout-item md-size-50 mx-auto">
                          <img :src="sally" alt="Sally Image" class="img-raised rounded-circle img-fluid">
                        </div>
                        <h4 class="card-title">Sally
                          <br>
                          <small class="card-description text-muted">Mom</small>
                        </h4>

                        <md-card-content>
                          <p class="card-description">I'm the wife and mom (duh). I keep things sane around here. I do the prep of the herbs to keep FiFi from cutting off his fingers and I've been known to take care of heart patients.</p>
                        </md-card-content>

                        <md-card-actions class="text-center">
                          <md-button href="javascript:void(0)" class="md-just-icon md-simple">
                            <a href="http://www.the-barkers.org/sally_barker_resume.pdf" target="_new"><i class="fas fa-file-pdf"></i></a>
                          </md-button>
                          <md-button href="javascript:void(0)" class="md-just-icon md-simple">
                            <a href="https://www.linkedin.com/in/sallybarker/" target="_new"><i class="fab fa-linkedin"></i></a>
                          </md-button>
                        </md-card-actions>
                      </md-card>
                    </div>
                  </div>
                  <div class="md-layout-item md-medium-size-33 md-small-size-100">
                    <div class="team-player">
                      <md-card class="md-card-plain">
                        <div class="md-layout-item md-size-50 mx-auto">
                          <img :src="sarah" alt="Rae Image" class="img-raised rounded-circle img-fluid">
                        </div>
                        <h4 class="card-title">Rae
                          <br>
                          <small class="card-description text-muted">Student</small>
                        </h4>

                        <md-card-content>
                          <p class="card-description">In school learning the how and why of body movement.</p>
                        </md-card-content>

                      </md-card>
                    </div>
                  </div>
                  <div class="md-layout-item md-medium-size-33 md-small-size-100">
                    <div class="team-player">
                      <md-card class="md-card-plain">
                        <div class="md-layout-item md-size-50 mx-auto">
                          <img :src="lucky" alt="Lucky Image" class="img-raised rounded-circle img-fluid">
                        </div>
                        <h4 class="card-title">Lucky
                          <br>
                          <small class="card-description text-muted">Katahua</small>
                        </h4>

                        <md-card-content>
                          <p class="card-description">Ugh...no, really - I am NOT a cat. <br/> Now pet me, you hairless ape!</p>
                        </md-card-content>
                      </md-card>
                    </div>
                  </div>
                  <div class="md-layout-item md-medium-size-33 md-small-size-100">
                    <div class="team-player">
                      <md-card class="md-card-plain">
                        <div class="md-layout-item md-size-50 mx-auto">
                          <img :src="daisy" alt="Daisy Image" class="img-raised rounded-circle img-fluid">
                        </div>
                        <h4 class="card-title">Daisy
                          <br>
                          <small class="card-description text-muted">Princess</small>
                        </h4>

                        <md-card-content>
                          <p class="card-description">So what if I jump at every little sound. <br/> P.R.I.N.C.E.S.S!</p>
                        </md-card-content>
                      </md-card>
                    </div>
                  </div>
                  <div class="md-layout-item md-medium-size-33 md-small-size-100">
                    <div class="team-player">
                      <md-card class="md-card-plain">
                        <div class="md-layout-item md-size-50 mx-auto">
                          <img :src="bacon" alt="Bacon Image" class="img-raised rounded-circle img-fluid">
                        </div>
                        <h4 class="card-title">Bacon
                          <br>
                          <small class="card-description text-muted">Honorary Child</small>
                        </h4>

                        <md-card-content>
                          <p class="card-description">Wuh? Don't tell me you don't have bacon in your family, too!</p>
                        </md-card-content>
                      </md-card>
                    </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  bodyClass: "landing-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/landing11.jpg")
    },
    phil: {
      type: String,
      default: require('@/assets/img/phil1.jpg')
    },
    sally: {
      type: String,
      default: require('@/assets/img/sally1.jpg')
    },
    sarah: {
      type: String,
      default: require('@/assets/img/sarah1.jpg')
    },
    daisy: {
      type: String,
      default: require('@/assets/img/daisy1.jpg')
    },
    lucky: {
      type: String,
      default: require('@/assets/img/lucky1.jpg')
    },
    bacon: {
      type: String,
      default: require('@/assets/img/bacon.jpg')
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
</style>
